module.exports = __webpack_public_path__ + "media/images/emblems/Oberglatt-blazon-ff3fb7a50761e32e6ab1265c94b0568d.svg";